import React from 'react';

interface OfflineIllustrationProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const OfflineIllustration: React.FC<OfflineIllustrationProps> = ({
  className,
  width = '100%',
  height = '100%',
}) => {
  return (
    <div className={className} style={{ width, height }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 400 300"
        fill="none"
      >
        <defs>
          <linearGradient id="offlineBG" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(var(--nextui-warning))" stopOpacity="0.1" />
            <stop offset="100%" stopColor="hsl(var(--nextui-warning))" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Background */}
        <ellipse cx="200" cy="250" rx="150" ry="30" fill="url(#offlineBG)" />

        {/* Device/Screen */}
        <rect x="100" y="80" width="200" height="140" rx="8" fill="hsl(var(--nextui-default-200))" />
        <rect x="110" y="90" width="180" height="110" rx="4" fill="hsl(var(--nextui-default-100))" />

        {/* WiFi symbol with slash */}
        <g transform="translate(200, 150)">
          {/* WiFi arcs */}
          <path
            d="M -30 10 Q -30 -20 0 -30 Q 30 -20 30 10"
            stroke="hsl(var(--nextui-warning))"
            strokeWidth="3"
            fill="none"
            opacity="0.3"
          />
          <path
            d="M -20 10 Q -20 -5 0 -15 Q 20 -5 20 10"
            stroke="hsl(var(--nextui-warning))"
            strokeWidth="3"
            fill="none"
            opacity="0.5"
          />
          <path
            d="M -10 10 Q -10 5 0 0 Q 10 5 10 10"
            stroke="hsl(var(--nextui-warning))"
            strokeWidth="3"
            fill="none"
            opacity="0.7"
          />
          <circle cx="0" cy="15" r="3" fill="hsl(var(--nextui-warning))" />

          {/* Slash through WiFi */}
          <line
            x1="-35"
            y1="25"
            x2="35"
            y2="-35"
            stroke="hsl(var(--nextui-danger))"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </g>

        {/* Cloud with X */}
        <g transform="translate(150, 50)">
          <ellipse cx="0" cy="0" rx="20" ry="12" fill="hsl(var(--nextui-default-300))" opacity="0.6" />
          <ellipse cx="15" cy="-5" rx="15" ry="10" fill="hsl(var(--nextui-default-300))" opacity="0.6" />
          <ellipse cx="-15" cy="-2" rx="12" ry="8" fill="hsl(var(--nextui-default-300))" opacity="0.6" />

          {/* X mark */}
          <line x1="-8" y1="-8" x2="8" y2="8" stroke="hsl(var(--nextui-danger))" strokeWidth="2" strokeLinecap="round" />
          <line x1="8" y1="-8" x2="-8" y2="8" stroke="hsl(var(--nextui-danger))" strokeWidth="2" strokeLinecap="round" />
        </g>
      </svg>
    </div>
  );
};

export default OfflineIllustration;
